import { render } from "./validate.vue?vue&type=template&id=09ccc1de&scoped=true"
import script from "./validate.vue?vue&type=script&lang=js"
export * from "./validate.vue?vue&type=script&lang=js"

import "./validate.vue?vue&type=style&index=0&id=09ccc1de&scoped=true&lang=css"
import "./validate.vue?vue&type=style&index=1&id=09ccc1de&lang=css"
script.render = render
script.__scopeId = "data-v-09ccc1de"

export default script